"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var react_select_1 = __importDefault(require("react-select"));
var md_1 = require("react-icons/md");
var double_arrow_right_svg_1 = __importDefault(require("../../../assets/svg/double-arrow-right.svg"));
var styles_1 = require("./styles");
var PaginationComponent = function (_a) {
    var count = _a.count, onChangePage = _a.onChangePage, rowsPerPage = _a.rowsPerPage, onChangeRowsPerPage = _a.onChangeRowsPerPage, options = _a.options, defaultNumberOfRows = _a.defaultNumberOfRows, background_active = _a.background_active, page = _a.page;
    var _b = __read(react_1.useState([]), 2), pages = _b[0], setPages = _b[1];
    var calcPagesRange = react_1.useCallback(function (inheritedPage) {
        var numberOfPages = Math.ceil(count / rowsPerPage);
        var numberOfItems = numberOfPages <= 5 ? numberOfPages : 5;
        var newPivotPage = inheritedPage >= 0 ? inheritedPage + 1 : 1;
        var limit = numberOfPages - newPivotPage < 2
            ? numberOfItems / 2 + 2 + newPivotPage - numberOfPages
            : numberOfItems / 2;
        var sum = Math.floor(1 +
            (newPivotPage > 3 && newPivotPage > numberOfItems - 2
                ? newPivotPage - limit
                : 0));
        return __spread(Array(numberOfItems).keys()).map(function (key) { return key + sum; });
    }, [count, rowsPerPage]);
    var skip = react_1.useCallback(function (event, inheritedPage) {
        var numberOfPages = Math.ceil(count / rowsPerPage);
        var newPage = inheritedPage;
        if (newPage > numberOfPages - 1) {
            newPage = numberOfPages - 1;
        }
        if (newPage < 0) {
            newPage = 0;
        }
        onChangePage(event, newPage);
        setPages(calcPagesRange(newPage));
    }, [calcPagesRange, onChangePage, count, rowsPerPage]);
    react_1.useEffect(function () {
        var calcPages = calcPagesRange(page);
        setPages(calcPages);
    }, [calcPagesRange, page]);
    var customStyles = {
        placeholder: function (provided) { return (__assign(__assign({}, provided), { fontSize: '13px', lineHeight: '45px', fontWeight: 400, color: '#b5b5c3' })); },
    };
    return (jsx_runtime_1.jsxs(styles_1.Container, { children: [jsx_runtime_1.jsxs("div", __assign({ className: "pagination" }, { children: [jsx_runtime_1.jsx("button", __assign({ type: "button", className: "double-arrow arrow", onClick: function (event) { return skip(event, page - 5); }, disabled: page <= 0 }, { children: jsx_runtime_1.jsx("img", { src: double_arrow_right_svg_1.default, alt: "" }, void 0) }), void 0),
                    jsx_runtime_1.jsx("button", __assign({ type: "button", className: "arrow", onClick: function (event) { return skip(event, page - 1); }, disabled: page <= 0 }, { children: jsx_runtime_1.jsx(md_1.MdKeyboardArrowLeft, { size: 20, color: "#4f4f4f" }, void 0) }), void 0),
                    jsx_runtime_1.jsx("div", __assign({ className: "links" }, { children: pages.map(function (page_) { return (jsx_runtime_1.jsx(styles_1.ButtonLink, __assign({ onClick: function (event) { return skip(event, page_ - 1); }, type: "button", backgroundActive: background_active, active: page + 1 === page_ }, { children: page_ }), page_)); }) }), void 0),
                    jsx_runtime_1.jsx("button", __assign({ type: "button", disabled: page + 1 >= Math.ceil(count / rowsPerPage), className: "arrow", onClick: function (event) { return skip(event, page + 1); } }, { children: jsx_runtime_1.jsx(md_1.MdKeyboardArrowRight, { size: 20, color: "#4f4f4f" }, void 0) }), void 0),
                    jsx_runtime_1.jsx("button", __assign({ disabled: page + 1 >= Math.ceil(count / rowsPerPage), type: "button", className: "double-arrow arrow", onClick: function (event) { return skip(event, page + 5); } }, { children: jsx_runtime_1.jsx("img", { src: double_arrow_right_svg_1.default, alt: "" }, void 0) }), void 0)] }), void 0),
            jsx_runtime_1.jsxs("div", __assign({ className: "pages" }, { children: [jsx_runtime_1.jsx("div", __assign({ className: "select" }, { children: jsx_runtime_1.jsx(styles_1.SelectContainer, { children: jsx_runtime_1.jsx(react_select_1.default, { classNamePrefix: "sel", name: "quantity", styles: customStyles, placeholder: "", defaultValue: {
                                    label: defaultNumberOfRows,
                                    value: defaultNumberOfRows,
                                }, onChange: function (value) {
                                    if (onChangeRowsPerPage)
                                        onChangeRowsPerPage(value === null || value === void 0 ? void 0 : value.value);
                                }, options: options || [
                                    {
                                        label: 3,
                                        value: 3,
                                    },
                                    {
                                        label: 5,
                                        value: 5,
                                    },
                                    {
                                        label: 10,
                                        value: 10,
                                    },
                                ] }, void 0) }, void 0) }), void 0),
                    jsx_runtime_1.jsx("div", __assign({ className: "text" }, { children: jsx_runtime_1.jsx("p", { children: "Registros " + (page * rowsPerPage + 1) + " a " + (
                            // (page + 1) * rowsPerPage
                            (__spread(Array(count).keys()).slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                .pop() || 0) + 1) + " total " + count }, void 0) }), void 0)] }), void 0)] }, void 0));
};
exports.default = PaginationComponent;
//# sourceMappingURL=index.js.map